'use strict';

import angular from 'angular';
import { Operator } from '../../operator/enum/operator';

/**
 * Сервис работы с проектами
 * @author Maxim Seredkin
 * @param {*} $modal
 * @param {*} ProjectRestService
 * @param {*} $location
 * @param {*} ModalService
 * @param {*} OperatorService
 * @return {*}
 */
export default ['$uibModal', 'ProjectRestService', '$location', 'ModalService', 'OperatorService',
                function($modal, ProjectRestService, $location, ModalService, OperatorService) {
                    let transactionId = null;
                    let pagination = {
                        isPaging: true,
                        page: 1,
                        size: 10,
                        totalPages: null,
                        totalItems: null,
                    };
                    let filter = getDefault();
                    let selectItem = {};
                    let defaultOperator = null;
                    let applyFilters = true;
                    let otherFilters = {
                        industry: [],
                        milestone: null,
                        hasExpirationMaintenance: 'ALL'
                    };

                    // OperatorService.api.default(null, (data) => {
                    //     //defaultOperator = data._embedded;
                    //     angular.copy(getDefault(), filter);
                    // });

                    return {
                        select: select,
                        setSelectItem: setSelectItem,
                        getSelectItem: getSelectItem,
                        create: create,
                        edit: edit,
                        remove: remove,
                        notify: notify,
                        moveToTrash: moveToTrash,
                        recovery: recovery,
                        getTransactionId: getTransactionId,
                        getPagination: getPagination,
                        getFilter: getFilter,
                        setFilter: setFilter,
                        resetFilter: resetFilter,
                        isApplyFilter: isApplyFilter,
                        applyFilter: applyFilter,
                        api: ProjectRestService,
                        getOtherFilters: getOtherFilters,
                        setOtherFilters: setOtherFilters,
                        rework: rework,
                    };

                    // region Function

                    /**
                     * Выбрать проект
                     * @param {*} item
                     */
                    function setSelectItem(item) {
                        selectItem = item;
                    }

                    /**
                     * Получить выбранный проект
                     * @return {{}}
                     */
                    function getSelectItem() {
                        return selectItem;
                    }

                    /**
                     * Фильтра применены?
                     * @return {boolean}
                     */
                    function isApplyFilter() {
                        return applyFilters;
                    }

                    /**
                     * Применить фильтра
                     * @param {*} apply
                     */
                    function applyFilter(apply) {
                        applyFilters = apply;
                    }

                    /**
                     * Получить фильтра по-умолчанию
                     * @return {{
                     *               operatorPlanStartYear: *,
                     *               operatorPlanEndYear: *,
                     *               operatorPlanFundsTotal: *,
                     *               operatorProfitPlanPaybackPeriod: *,
                     *               operatorProfitPlanBudgetPayments: *,
                     *               operatorProfitPlanIrr: *,
                     *               operatorProfitPlanNpv: *,
                     *               operatorProfitPlanWplaces: *,
                     *               operatorStartSupportYear: *,
                     *               placeMunicipality: {id: null},
                     *               status: {id: null},
                     *               maintenanceKind: {id: null},
                     *               supportTool: {id: null},
                     *               industry: {id: null},
                     *               phase: {id: null},
                     *               startSupportYear: null,
                     *               investorSearchRequired: boolean,
                     *               enableInvestorSearchRequired: boolean,
                     *               insider: boolean,
                     *               enableinsiderRequired: boolean,
                     *               posinsider: boolean,
                     *               enableposinsiderRequired: boolean,
                     *               area: {id: null},
                     *               planEndYear: null
                     *          }}
                     */
                    function getDefault() {
                        defaultOperator = null;
                        return {
                            operatorPlanStartYear: defaultOperator,
                            operatorPlanEndYear: defaultOperator,
                            operatorPlanFundsTotal: defaultOperator,
                            operatorProfitPlanPaybackPeriod: defaultOperator,
                            operatorProfitPlanBudgetPayments: defaultOperator,
                            operatorProfitPlanIrr: defaultOperator,
                            operatorProfitPlanNpv: defaultOperator,
                            operatorProfitPlanWplaces: defaultOperator,
                            operatorStartSupportYear: defaultOperator,
                            placeMunicipality: [],
                            status: {id: null},
                            maintenanceKind: {id: null},
                            supportTool: {id: null},
                            industry: [],
                            phase: [],
                            startSupportYear: null,
                            investorSearchRequired: false,
                            enableInvestorSearchRequired: false, // removed
                            resident: false,
                            enableinsiderRequired: false, //  removed
                            potentialResident: false,
                            enableposinsiderRequired: false, //  removed
                            enableFederalFinancing: false, // removed
                            federalFinancing: false,
                            enableRegionalFinancing: false, // removed
                            regionalFinancing: false,
                            enableMunicipalFinancing: false, // removed
                            municipalFinancing: false,
                            enableOwnFinancing: false, // removed
                            ownFinancing: false,
                            isGCHP: false,
                            signed: false,
                            enableSigned: false,
                            dateFinancing: {startDate: null, endDate: null},
                            area: {id: null},
                            planEndYear: null
                        };
                    }

                    /**
                     * Установить значения фильтров
                     * @param {*} f фильтра
                     */
                    function setFilter(f) {
                        filter = f;
                    }

                    /**
                     * Сбросить фильтра
                     */
                    function resetFilter() {
                        angular.copy(getDefault(), filter);
                    }

                    /**
                     * Получить пейджинацию
                     * @return {{isPaging: boolean, page: number, size: number, totalPages: null, totalItems: null}}
                     */
                    function getPagination() {
                        return pagination;
                    }

                    /**
                     * Получить фильтра
                     * @return {{operatorPlanStartYear, operatorPlanEndYear, operatorPlanFundsTotal, operatorProfitPlanPaybackPeriod, operatorProfitPlanBudgetPayments, operatorProfitPlanIrr, operatorProfitPlanNpv, operatorProfitPlanWplaces, operatorStartSupportYear, placeMunicipality, status, maintenanceKind, supportTool, industry, phase, startSupportYear, investorSearchRequired, enableInvestorSearchRequired, insider, enableinsiderRequired, posinsider, enableposinsiderRequired, area}}
                     */
                    function getFilter() {
                        return filter;
                    }

                    /**
                     * Получить идентификатор транзакции
                     * @return {*}
                     */
                    function getTransactionId() {
                        return transactionId;
                    }

                    /**
                     * Выбрать проект
                     * @param {*} project
                     * @param {*} filters
                     * @param {*} def
                     */
                    function select(project, filters, def) {
                    }

                    /**
                     * Создать проект
                     * @param {*} def
                     * @return {*}
                     */
                    function create(def) {
                        return $modal.open({
                            template: require('../view/project-modal-create.html'),
                            controller: 'ProjectModalCreateController',
                            size: 'md',
                            backdrop: false,
                            resolve: {
                                project: function() {
                                    return {};
                                },
                            },
                        });
                    }

                    function notify(filters, searchs) {
                        return $modal.open({
                            template: require('../view/project-modal-notify.html'),
                            controller: 'ProjectModalNotifyController',
                            size: 'lg',
                            backdrop: false,
                            resolve: {
                                filters: function() {
                                    return filters;
                                },
                                searchs: function() {
                                    return searchs;
                                }
                            },
                        });
                    }

                    /**
                     * Редактировать проект
                     * @param {*} project проект
                     * @param {*} trnId идентификатор транзакции
                     */
                    function edit(project, trnId) {
                        if (trnId) {
                            transactionId = trnId;
                        } else {
                            transactionId = null;
                        }
                        $location.url('projects/' + project.id);
                    }

                    /**
                     * Удалить проект
                     * @param {*} project проект
                     * @param {*} callback
                     */
                    function remove(project, callback) {
                        ModalService.danger({
                                                message: 'Запись будет удалена без возможности восстановления! Вы действительно желаете удалить данную запись?',
                                                apply: 'Да',
                                                cancel: 'Нет',
                                            }).result.then(() => ProjectRestService.remove({projectId: project.id}, null, (data) => callback(data)));
                    }

                    /**
                     * Восстановить проект
                     * @param {*} project проект
                     * @param {*} callback
                     */
                    function recovery(project, callback) {
                        ModalService.warning({
                                                 message: 'Запись будет восстановлена! Вы действительно желаете восстановить данную запись?',
                                                 apply: 'Да',
                                                 cancel: 'Нет',
                                             }).result.then(() => ProjectRestService.recovery({projectId: project.id}, null, (data) => callback(data)));
                    }

                    /**
                     * Переместить проект в корзину
                     * @param {*} project проект
                     * @param {*} callback
                     */
                    function moveToTrash(project, callback) {
                        ModalService.danger({
                                                message: 'Запись будет перемещена в корзину! Вы действительно желаете переместить данную запись в корзину?',
                                                apply: 'Да',
                                                cancel: 'Нет',
                                            }).result.then(() => ProjectRestService.moveToTrash({projectId: project.id}, null, (data) => callback(data)));
                    }

                    /**
                     * Получить другие фильтра
                     * @return {{}}
                     */
                    function getOtherFilters() {
                        return otherFilters;
                    }

                    /**
                     * Задать другие фильтра
                     * @param {*} oFilters
                     */
                    function setOtherFilters(oFilters) {
                        otherFilters = oFilters;
                    }

                    /**
                     * Переработать проект
                     * @param {*} project проект
                     * @param {*} callback
                     */
                    function rework(project, callback) {
                        ModalService.warning({
                                                 message: 'Запись будет переработана! Вы действительно желаете переработать данную запись?',
                                                 apply: 'Да',
                                                 cancel: 'Нет',
                                             }).result.then(() => ProjectRestService.rework({projectId: project.id}, null, (data) => callback(data)));
                    }

                    // endregion
                }];
